import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, Input } from '@angular/core'
import { Breadcrumb } from '@modules/navigation/models'
import { NavigationService } from '@modules/navigation/services'
import { Subscription } from 'rxjs'

@Component({
	selector: 'sb-breadcrumbs',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './breadcrumbs.component.html',
	styleUrls: ['breadcrumbs.component.scss'],
	standalone: false
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
	breadcrumbs: Breadcrumb[] | undefined = []
	subscription: Subscription = new Subscription()

	constructor(public navigationService: NavigationService) {}

	ngOnInit() {
		this.subscription.add(
			this.navigationService.routeData$().subscribe(routeData => {
				this.breadcrumbs = routeData.breadcrumbs
			})
		)
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
